module.exports = __webpack_public_path__ + "static/media/10.983511fb.jpeg";